import { useState, useEffect } from "react";
import { Tools } from "../utils";

const isMobileView = () =>
  window.innerWidth <
  Number(Tools.getCssVar("mobile-breakpoint").replace("px", ""));

const useDevice = () => {
  const [isMobile, setIsMobile] = useState(isMobileView());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileView());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile };
};

export default useDevice;
